import React from "react";
import { Marquee } from "./EditorialMarquee";

const WORDS = ["Empathy", "Clarity", "ADHD Care", "Mood Balance", "Confidentiality", "Healing Space", "Resilience", "Non-Judgment"];

export const EditorialMarqueeSection = () => (
  <section className="py-8 border-y border-[#C9DFAC] bg-[#DFF0C4]/50 overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center">
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center">
              <span className="font-serif italic text-2xl sm:text-3xl text-[#3A7D32] px-8">{w}</span>
              <span className="text-[#FFC9A0] text-2xl">✳</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
